/**Checks if the text with is bigger than the input width*/
const showLargeInputs =  {
    bind: function (el) {
        el.addEventListener('mouseenter', addModal);
        el.addEventListener('mouseleave', removeModal);
        document.addEventListener('scroll', removeModal);
    },
    unbind: function (el) {
        document.removeEventListener('scroll', removeModal);
    }
}
const addModal = (e) => {
    try {
        if (!e.target) throw new Error('No input');
        
        let fontSize = window.getComputedStyle(e.target, null).getPropertyValue('font-size');
        let textWidth = getWidth(fontSize, e.target.value);        
        const width = e.target.clientWidth;
        
        const addHover = textWidth + 3 > width;       
        if(typeof addHover === 'boolean' && addHover === true){                
            const modal = `<div id="input-modal" style="position:fixed; z-index:9999; font-size:15px;"><div class="card" style="width: max-content; display: flex; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.09); border-bottom: 1.5px solid #ddd; border-right: 1.5px solid #ddd;">${e.target.value}</div></div>`;
            document.body.insertAdjacentHTML('afterend', modal);
            setTimeout(() => {
                import('vue').then((v)=>{
                    v.default.nextTick(()=>{
                        let input = e.target;
                        let inputModal = document.querySelector('#input-modal');
                        (input && inputModal) && setPreviewPosition(input, inputModal);
                    });
                });
            }, 10);
            
        }
    } catch (error) {
        console.error(error);
    }
}
const removeModal = (e) => {  
    try {
        if (!e.target) throw new Error('No input');
        let modal = document.querySelector('#input-modal');
        if(modal){       
            modal.remove(); 
        }            
    } catch (error) {
        console.error("error", error);
    }        
}
const setPreviewPosition =  function(input , modal) {
    const child = modal;
    const relative = input;

    const offset = {
      top: 3,
      left: 0
    }

    const { top, left, width , height} = relative.getBoundingClientRect();
    
    child.style.top = (top + height + offset.top) + 'px';
    child.style.left = (left + width) + 'px';

    // Check if it is outside the window.
    const childBounds = child.getBoundingClientRect();
    const windowOffset = 10;
    
    if (childBounds.bottom >= (window.innerHeight || document.documentElement.clientHeight) - windowOffset) {
      const diff = childBounds.bottom - (window.innerHeight || document.documentElement.clientHeight);
      child.style.top = (childBounds.top - diff - windowOffset) + 'px';
    }

    if (childBounds.right >= (window.innerWidth || document.documentElement.clientWidth) - windowOffset) {
      child.style.left = (left - childBounds.width - offset.left) + 'px';
    }
  }
/**Gets the width of the text in an invisible div*/
const getWidth = (fontSize, value) => {
    let div = document.createElement('div');
    div.innerHTML = value;
    div.id = 'test-input-width';
    div.style.fontSize = fontSize;
    div.style.width = 'auto';
    div.style.display = 'inline-block';
    div.style.visibility = 'hidden';
    div.style.position = 'fixed';
    div.style.overflow = 'auto';
    document.body.append(div);
    let width = div.clientWidth;

    return width;
};

export default showLargeInputs;
    